export default __webpack_public_path__ + "static/media/AYA_Valuators.272ee4bd.png";